<template>
    <div 
        class="group relative bg-white dark:bg-dark-800 shadow-sm hover:shadow-md rounded-lg overflow-hidden transition-all duration-200 flex flex-col h-48"
        :class="{ 'opacity-50 cursor-not-allowed': isClose }"
    >
        <!-- Image Section -->
        <div class="relative h-24 bg-gray-100 dark:bg-dark-700">
            <img 
                v-if="product.image" 
                :src="product.image" 
                :alt="productName"
                class="w-full h-full object-cover"
            />
            <div v-else class="w-full h-full flex items-center justify-center text-gray-400 dark:text-gray-600">
                <PhotoIcon class="w-8 h-8" />
            </div>
        </div>

        <!-- Content Section -->
        <div class="flex flex-col flex-grow p-3">
            <!-- Product Name -->
            <h3 class="font-medium text-gray-900 dark:text-gray-100 text-sm line-clamp-1">
                {{ productName }}
            </h3>
            
            <!-- Price -->
            <p class="text-blue-600 dark:text-blue-400 font-bold mt-1">
                {{ formatPrice(productPrice) }}
            </p>

            <!-- Add Button -->
            <button 
                :id="btnAddItem" 
                @click="$emit('add-order', product)"
                :disabled="isClose"
                class="mt-auto w-full py-1.5 px-3 rounded-md text-sm font-medium transition-colors duration-200
                    bg-blue-500 hover:bg-blue-600 text-white
                    dark:bg-blue-600 dark:hover:bg-blue-700
                    disabled:opacity-50 disabled:cursor-not-allowed
                    flex items-center justify-center gap-2"
            >
                <PlusIcon class="w-4 h-4" />
                Tambah
            </button>
        </div>
    </div>
</template>

<script>
import { PhotoIcon, PlusIcon } from '@heroicons/vue/24/outline'

export default {
    name: 'ProductCard',
    components: {
        PhotoIcon,
        PlusIcon
    },
    props: {
        productName: {
            type: String,
            required: true
        },
        productPrice: {
            type: String,
            required: true
        },
        product: {
            type: Object,
            required: true
        },
        btnAddItem: {
            type: String,
            required: true
        },
        isClose: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        formatPrice(price){
            return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(price);
        }
    }
}
</script>